import React from "react";
import "./UploadFAQs.css";

const UploadFAQs = () => {
  return (
    <div className="xena-faqs-docs">
      <h1 className="xena-faqs-title">Uploading FAQs and Answer Sets</h1>

      <p className="xena-faqs-intro">
        Learn how to add frequently asked questions and their answers to your XenaChat assistant.  
        Your assistant can use these FAQs to provide accurate and context-aware responses.
      </p>

      <h2 className="xena-faqs-step">Step 1 – Access FAQs</h2>
      <p>
        From your bot’s training dashboard, click on the <strong>FAQs</strong> tab.
      </p>

      <h2 className="xena-faqs-step">Step 2 – Add Questions and Answers</h2>
      <p>
        Input your question and its corresponding answer, then click the <strong>Add FAQ & Rebuild</strong> button.
      </p>

      <h2 className="xena-faqs-step">Step 3 – View Previously Added FAQs</h2>
      <p>
        Once added, you can see all your previously uploaded FAQs listed just below the <strong>Add FAQ & Rebuild</strong> button.  
        Your assistant will now be able to reference these FAQs when responding to users.
      </p>
    </div>
  );
};

export default UploadFAQs;
